// extracted by mini-css-extract-plugin
export default {"content":"checkbox_content__T2Y5t"};